import { render, staticRenderFns } from "./UpcomingDailyMeals.vue?vue&type=template&id=455db93a"
import script from "./UpcomingDailyMeals.vue?vue&type=script&lang=js"
export * from "./UpcomingDailyMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports